<template>  
  <mu-appbar class="XR-purchase-search-head">
    <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
    <div slot="default" class="search-ctrl">
      <div class="input-ctrl" @click="goSearch">
        <mu-chip v-if="searchKey !=''" class="XR-purchase-search-head-chip" @click="editKey" @delete="deleteKey" showDelete>
          {{searchKey}}
        </mu-chip>
      </div>          
      <div class="icon-ctrl" @click="goSearch()"><i class="fa fa-search"></i></div>
    </div>
    <mu-icon-menu icon=":fa fa-more" slot="right">
      <mu-menu-item to="/salesman/index" title="代理中心"/>
      <mu-menu-item to="/" title="首页"/>
      <mu-menu-item to="/wholesale/cart" title="购物车"/>
    </mu-icon-menu>
  </mu-appbar>
</template>

<script>
export default {
  name : 'XR-purchase-search-head',
  data () {
    return {
      goToUrl : this.url,
      searchKey : this.$route.query.searchKey ? this.$route.query.searchKey : ''
    }
  },
  props:{
    url: String,
    mode: String
  },
  mounted:function(){

  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    editKey(){
      var url = "/wholesale/search?searchKey="+this.searchKey
      this.$router.push(url)
    },
    deleteKey(){
      this.$router.push("/wholesale/search")
    },
    goSearch(){
      if(this.mode == "list"){ //产品列表
        var url = "/wholesale/search?searchKey="+this.searchKey
        this.$router.push(url)
      }
      else if(this.mode == "category"){ //产品列表        
        this.$router.push('/wholesale/search')
      }
    }
  }
}
</script>

<style>
.XR-purchase-search-head{
  height: 48px;
  text-align: center;
}
.XR-purchase-search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.XR-purchase-search-head .mu-appbar-title {
  font-size: 16px;
}
.XR-purchase-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.XR-purchase-search-head .title .title-text {
  margin: 0;
  line-height: 48px;
}


.XR-purchase-search-head .search-ctrl{
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  padding-right: 10px;
  color:#ccc;
  background: #999;
  overflow: hidden;
}
.XR-purchase-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  height: 32px;
  font-size: 12px;
  width: 90%;
  padding-left: 12px;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
}
.XR-purchase-search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 32px;
  text-align: right;
  color:white;
}

.XR-purchase-search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.XR-purchase-search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/usercenter/purchaseSearchHead/searchHead.vue